import ArticleLayout from '@/pages/articles/components/ArticleLayout';

export default function YoybuyVsSuperbuy() {
  return <ArticleLayout slug="yoybuy-vs-superbuy" />;
}